var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAiReview = function SvgAiReview(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aiReview_svg__a)",
    d: "M3.6 3.6h16.8v10.9h1.2V2.4H2.4v19.2H15v-1.2H3.6zM23 19a6.66 6.66 0 0 1-3.5-3.5A6.66 6.66 0 0 1 16 19a6.66 6.66 0 0 1 3.5 3.5A6.66 6.66 0 0 1 23 19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.547 7.713 6.57 15.474h1.402L8.7 13.42h3.098l.727 2.055h1.457l-2.989-7.76zm-.478 4.674 1.174-3.337h.033l1.163 3.337zm5.815-4.674v7.761h1.36v-7.76z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aiReview_svg__a",
    x1: 2.1,
    x2: 21.3,
    y1: 21.3,
    y2: 2.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF74F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#145FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CEBCD"
  })))));
};
export { SvgAiReview as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='url(%23paint0_linear_9304_1501)' d='M3.6 3.6h16.8v10.9h1.2V2.4H2.4v19.2H15v-1.2H3.6zM23 19a6.66 6.66 0 0 1-3.5-3.5A6.66 6.66 0 0 1 16 19a6.66 6.66 0 0 1 3.5 3.5A6.66 6.66 0 0 1 23 19'/%3e%3cpath fill='currentColor' d='M9.547 7.713 6.57 15.474h1.402L8.7 13.42h3.098l.727 2.055h1.457l-2.989-7.76zm-.478 4.674 1.174-3.337h.033l1.163 3.337zm5.815-4.674v7.761h1.36v-7.76z'/%3e%3cdefs%3e%3clinearGradient id='paint0_linear_9304_1501' x1='2.1' x2='21.3' y1='21.3' y2='2.1' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23EF74F2'/%3e%3cstop offset='.5' stop-color='%23145FEF'/%3e%3cstop offset='1' stop-color='%235CEBCD'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";